import React from 'react';

const PlayerRow = ({ player, rank, onClick }) => {
  // Title colors
  const getTitleColor = (title) => {
    switch(title) {
      case 'GM': return 'text-yellow-400';
      case 'IM': return 'text-orange-400';
      case 'FM': return 'text-blue-400';
      case 'WGM': return 'text-yellow-400';
      case 'WIM': return 'text-orange-400';
      case 'WFM': return 'text-blue-400';
      case 'CM': return 'text-green-400';
      case 'WCM': return 'text-green-400';
      default: return 'text-gray-400';
    }
  };

  // Rating change color
  const getRatingChangeColor = (change) => {
    if (change > 0) return 'text-green-400';
    if (change < 0) return 'text-red-400';
    return 'text-gray-400';
  };

  // Country flag emoji mapping (simplified - expand as needed)
  const getCountryFlag = (country) => {
    const flags = {
      'USA': '🇺🇸',
      'RUS': '🇷🇺',
      'CHN': '🇨🇳',
      'IND': '🇮🇳',
      'NOR': '🇳🇴',
      'FRA': '🇫🇷',
      'GER': '🇩🇪',
      'ESP': '🇪🇸',
      'ITA': '🇮🇹',
      'NED': '🇳🇱',
      'POL': '🇵🇱',
      'UKR': '🇺🇦',
      'ENG': '🇬🇧',
      'GBR': '🇬🇧',
      'ARM': '🇦🇲',
      'AZE': '🇦🇿',
      'ISR': '🇮🇱',
      'HUN': '🇭🇺',
      'CZE': '🇨🇿',
      'GRE': '🇬🇷',
      'BUL': '🇧🇬',
      // Add more as needed
    };
    return flags[country] || '🏳️';
  };

  return (
    <tr 
      className="hover:bg-gray-700 cursor-pointer transition-colors"
      onClick={onClick}
    >
      <td className="px-4 py-3 text-sm text-center">
        <span className="font-medium text-gray-100">{rank}</span>
      </td>
      <td className="px-4 py-3 text-sm text-center">
        <span className="font-bold text-gray-100">{player.rating}</span>
      </td>
      <td className="px-4 py-3 text-sm">
        <span className="font-medium text-gray-100">{player.name}</span>
      </td>
      <td className="px-4 py-3 text-sm">
        <div className="flex items-center gap-2">
          <span className="text-xl">{getCountryFlag(player.country)}</span>
          <span className="text-gray-400">{player.country}</span>
        </div>
      </td>
      <td className="px-4 py-3 text-sm text-center text-gray-400">
        {player.age || '-'}
      </td>
      <td className="px-4 py-3 text-sm text-center">
        {player.rankChange !== null && player.rankChange !== undefined ? (
          <span className={`font-medium ${player.rankChange > 0 ? 'text-green-400' : player.rankChange < 0 ? 'text-red-400' : 'text-gray-400'}`}>
            {player.rankChange > 0 ? '↑' : player.rankChange < 0 ? '↓' : ''}
            {Math.abs(player.rankChange) || '--'}
          </span>
        ) : (
          <span className="text-gray-400">--</span>
        )}
      </td>
      <td className="px-4 py-3 text-sm text-center">
        {player.ratingChange !== null && player.ratingChange !== undefined ? (
          <span className={`font-medium ${getRatingChangeColor(player.ratingChange)}`}>
            {player.ratingChange > 0 && '+'}
            {player.ratingChange}
          </span>
        ) : (
          <span className="text-gray-400">--</span>
        )}
      </td>
    </tr>
  );
};

export default PlayerRow;